    <div class="flex justify-content-center p-0">
        <div class="p-col-12 p-md-12 p-lg-6 px-3 py-0">
            <div class="flex justify-content-center p-0">
                <div class="p-col-12 p-md-6 p-lg-3 p-0">
                    <h3 >{{ 'h3.cycleCounting' | translate }}</h3>
                </div>
            </div>

            <div *ngIf="selectedZone && cycleCountingResponse">
                <p>
                    {{ 'h5.countType' | translate }}: 
                    <span [ngStyle]="{'color': cycleCountingResponse[itemList].cycleCountTypeC == countType.RECOUNT ? 'red' : 'black'}">
                        {{cycleCountingResponse[itemList].cycleCountTypeC == 'R'? this.translate.instant('h5.recount') : this.translate.instant('h5.count')}}
                    </span>
                </p>
            </div>

            <div class="pb-0">
                <label>{{ 'h5.zone' | translate }}</label>
                <p-select 
                    [options]="returnedZones$ | async" 
                    [(ngModel)]="selectedZone"
                    placeholder="{{ 'h5.selectZone' | translate }}" (ngModelChange)="checkDropdownValid()" optionLabel="zoneC"
                    [showClear]="true">
                </p-select>
            </div>

            <div class="card pl-3 pb-2 pt-0" *ngIf="selectedZone && cycleCountingResponse">
                <div class="p-1 z-0">
                    <h5>{{ 'h5.quantityToCounted' | translate }}: <span class="text-sm opacity-60 ">{{ itemScreen}} / {{cycleCountingResponse.length }}</span></h5>
                    <h5>{{ 'h5.part' | translate }}: <span class="text-sm opacity-60 ">{{ cycleCountingResponse[itemList].partName }}</span></h5>
                    <h5 *ngIf="cycleCountingResponse[itemList].conversionPartName">{{ (cycleCountingResponse[itemList].convertedPartGSPNF === 'Y' ? 'h5.newPart' : 'h5.oldPart') | translate }}: <span class="text-sm opacity-60 ">{{ cycleCountingResponse[itemList].conversionPartName }}</span></h5>
                    <h5>{{ 'h5.description' | translate }}: <span class="text-sm opacity-60 ">{{ cycleCountingResponse[itemList].description | uppercase }}</span></h5>
                    <h5>{{ 'h5.staging' | translate }}: <span class="text-sm opacity-60 ">{{ cycleCountingResponse[itemList].location }}</span></h5>
                </div>
            </div>     
            <div class="card pl-3 pb-2 pt-0" *ngIf="!selectedZone && !cycleCountingResponse && currentZoneName">
                <div class="p-1 z-0 text-center">
                    <h5>{{ 'h3.countFinished' | translate }} <span class="text-sm opacity-60 ">{{ currentZoneName }}</span></h5>
                </div>
            </div>

            <div class="pb-0">
                <label>{{ 'h5.staging' | translate }}</label>
                <input type="text" pInputText tabindex="-1"
                [disabled]="!selectedZone" (keydown.enter)="checkLocation()"
                [(ngModel)]="locationValue" (ngModelChange)="invalidLocation()">
            </div>

 
            <div class="pb-0">
                <label>{{ 'h5.quantity' | translate }}</label>
                <input type="number" pInputText min="0" tabindex="-1"
                [disabled]="enableQuantity" (keydown.enter)="validQuantity()"
                [(ngModel)]="quantityValue" (ngModelChange)="invalidQuantity()"
                onkeydown="if(event.key==='.' || event.key==='-' || event.key==='+' || event.key==='e'){event.preventDefault();}">
            </div>
            
            <div class="flex justify-content-center p-0">
                <div class="p-col-12 p-md-6 p-lg-3 p-0">
                    <button pButton class="skipButton submit" (click)="skipCountingPart()" [disabled]="skipButtonDisable || !selectedZone">{{ 'button.skip' | translate }}</button>
                    <button pButton class="saveButton submit" (click)="saveCountingPart()" [disabled]="saveIsOk">{{ 'button.save' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
